// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SocialDiscordComponent} from './SocialDiscord.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSocialDiscord = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SocialDiscordComponent/>
  </Icon>
));
